export enum columnType {
    G_M = 'G-M',
    G_S1S2 = 'G-S1S2',
    G_XL = 'G-XL',
    G_L1L2 = 'G-L1L2',
    V_P3 = 'V-P3',
    V_P4_1 = 'V-P4-1',
    V_P4_2 = 'V-P4-2',
    V_P4H = 'V-P4H',
    V_P5 = 'V-P5',
    V_P5H_S1S2 = 'V-P5H-S1S2',
    V_P5H_XL = 'V-P5H-XL',
    O_TH = 'O-TH',
    O_TLH2 = 'O-TLH2',
    none = 'none',
}